import React, { useEffect, useState } from 'react';
import { Grid, Typography, Box, TextField, InputAdornment } from '@mui/material';
import { Clear, Search } from '@mui/icons-material';

const CaseCard = (data) => {

    const [search, setSearch] = useState('')
    let [showData, setShowData] = useState([])

    useEffect(() => {
        let myShowData = Object.entries(data).map(([key, value]) => {
            value = value === true ? 'Yes' : value === false ? 'No' : value || 'N/A'
            let label = key.replace(/_/g, ' ').toUpperCase()
            return { name: key, value, label }
        })
        setShowData(myShowData)
    }, [data])

    const includes = val => search ? val?.toString().toLowerCase().includes(search.toLowerCase()) : true

    showData = showData.filter(d => includes(d.name) || includes(d.label) || includes(d.value))

    return (
        <Box padding={4}>
            <Box display={{ sm: 'flex', }} alignItems={'center'}>
                <Typography flex={1} variant='h5'>Case Details</Typography>
                <TextField
                    autoComplete='off'
                    onChange={e => setSearch(e.target.value)}
                    size='small'
                    placeholder='Search'
                    value={search}
                    InputProps={{ endAdornment: search ? <span className='cursor-pointer' onClick={() => setSearch('')}><Clear /></span> : <Search /> }}
                />
            </Box>
            <br />
            <Grid container spacing={2}>
                {showData.map((d) => {
                    let { name, value, label } = d
                    return (
                        <Grid item xs={12} sm={6} md={2} key={name}>
                            <Typography variant="subtitle2" color="textSecondary">
                                {label}
                            </Typography>
                            <Typography variant="body1">
                                {value}
                            </Typography>
                        </Grid>
                    )
                })}
            </Grid>
        </Box>
    );
};

export default CaseCard;
